// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  height: 100vh;
  position: relative;
  background: black;
  text-transform: capitalize;
}

.header-btn ion-icon {
  right: 5px;
  top: 10px;
  position: absolute;
}

.wrapper {
  color: var(--randy-gray-dark);
  padding: 30px 22px 30px;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  margin-top: 12px;
  font-size: 26px;
  font-family: AppFontBold, sans-serif;
}

.email {
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
}

a {
  text-decoration: none;
  color: white;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  max-width: max-content;
  margin-right: auto;
}
.footer-lang .active {
  background: var(--randy-gray);
  border-color: var(--randy-gray);
}
.footer-lang .active span {
  color: #fff;
}
.footer-lang div {
  text-align: center;
  width: 48%;
  border: 0.6px solid;
  border-radius: 2px;
  overflow: hidden;
  padding: 7px 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(0, 0, 0, 0.3019607843);
  width: -moz-fit-content;
  width: fit-content;
}
.footer-lang div span {
  margin-left: 10px;
  text-transform: uppercase;
  font-family: AppFont;
  font-size: 12px;
  color: #000;
}
.footer-lang div ion-icon {
  height: 15px;
  width: 15px;
}

ion-col {
  font-family: AppFont;
  font-size: 20 px;
  font-weight: 500;
  line-height: 28.8px;
  text-align: left;
  color: #000000;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: white;
  color: #000000;
  font-weight: 700;
}
.logout ion-button ion-icon {
  zoom: 1;
  color: #000000;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.lang-row {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background: #80735d;
  padding: 15px;
}
.lang-row ion-icon {
  zoom: 1.3;
}

.lang-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lang-section ion-button {
  width: 48%;
  --border-color: white;
  --background: transparent;
  --border-color: white;
  --border-width: 2px;
  --border-style: solid;
  border-radius: 10px;
  --border-radius: 10px;
  overflow: hidden;
  background: transparent;
  font-weight: bold;
}
.lang-section ion-button.selected {
  --border-style: solid;
  --border-color: white;
  --border-width: 2px;
  --background: white;
  color: var(--ion-color-primary);
}

.icon-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.icon-lang ion-icon {
  margin: 0px !important;
  padding: 0px !important;
  zoom: 1.6;
}

.lang-block {
  margin-top: auto;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.link {
  display: flex;
  align-items: center;
}

.top-corner {
  position: fixed;
  top: 0px;
  left: 0;
  width: 17.3%;
  aspect-ratio: 114/153;
}
@media (min-width: 991px) {
  .top-corner {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;AADD;;AAIC;EACC,UAAA;EACA,SAAA;EACA,kBAAA;AADF;;AAIA;EACC,6BAAA;EACA,uBAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;AAFD;;AAKA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAFD;;AAKA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAFD;;AAKA;EACC,kBAAA;AAFD;;AAKA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AAFD;;AAKA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;AAFD;;AAIA;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AADD;;AAIA;EACC,qBAAA;EACA,YAAA;AADD;;AAIA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AADD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;AAAD;AACC;EACC,6BAAA;EACG,+BAAA;AACL;AAAE;EACC,WAAA;AAEH;AACC;EACC,kBAAA;EACA,UAAA;EACA,mBAAA;EACK,kBAAA;EACL,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACK,+CAAA;EACL,uBAAA;EAAA,kBAAA;AACF;AAAE;EACC,iBAAA;EACA,yBAAA;EACQ,oBAAA;EACR,eAAA;EACA,WAAA;AAEH;AAAE;EACC,YAAA;EACA,WAAA;AAEH;;AAEA;EACC,oBAAA;EACA,gBAAA;EACG,gBAAA;EACH,mBAAA;EACA,gBAAA;EACA,cAAA;AACD;;AAEA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AACD;;AACA;EACC,SAAA;AAED;;AAAA;EACC,yBAAA;AAGD;AAFC;EACC,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAIF;AAHE;EACC,OAAA;EACA,cAAA;AAKH;;AAAA;EACC,eAAA;AAGD;;AADA;EACC,YAAA;AAID;;AAFA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAKD;AAJC;EACC,SAAA;AAMF;;AAHA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAMD;AALC;EACC,UAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAOF;AAJE;EACC,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AAMH;;AAFA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAKD;AAJI;EACF,sBAAA;EACA,uBAAA;EACA,SAAA;AAMF;;AAFA;EACC,gBAAA;AAKD;;AAFA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAKD;;AAHA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAMD;;AAHA;EACC,aAAA;EACA,mBAAA;AAMD;;AAHA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AAMD;ACzOE;ED8NF;IAQE,aAAA;EAOA;AACF","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\napp-menu-modal {\n\theight: 100vh;\n\tposition: relative;\n\tbackground: black;\n\ttext-transform: capitalize;\n}\n.header-btn {\n\tion-icon {\n\t\tright: 5px;\n\t\ttop: 10px;\n\t\tposition: absolute;\n\t}\n}\n.wrapper {\n\tcolor: var(--randy-gray-dark);\n\tpadding: 30px 22px 30px;\n\theight: 100vh;\n\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.separator {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 16px 0;\n\tbackground: white;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\tfont-size: x-small;\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\n.name {\n\tmargin: 0px;\n\tmargin-top: 12px;\n\tfont-size: 26px;\n\tfont-family: AppFontBold, sans-serif;\n}\n.email {\n\tmargin: 0px;\n\tfont-size: 14px;\n\tmargin-top: 2px;\n\tfont-family: AppFont, sans-serif;\n}\n\na {\n\ttext-decoration: none;\n\tcolor: white;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 5px;\n\tmax-width: max-content;\n\tmargin-right: auto;\n\t.active {\n\t\tbackground: var(--randy-gray);\n    \tborder-color: var(--randy-gray);\n\t\tspan {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\tdiv {\n\t\ttext-align: center;\n\t\twidth: 48%;\n\t\tborder: 0.6px solid;\n\t      border-radius: 2px;\n\t\toverflow: hidden;\n\t\tpadding: 7px 13px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n       border: 0.5px solid #0000004D;\n\t\twidth: fit-content;\n\t\tspan {\n\t\t\tmargin-left: 10px;\n\t\t\ttext-transform: uppercase;\n\t          font-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: #000;\n\t\t}\n\t\tion-icon {\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t}\n\t}\n}\nion-col {\n\tfont-family: AppFont;\n\tfont-size: 20 px;\n    font-weight: 500;\n\tline-height: 28.8px;\n\ttext-align: left;\n\tcolor: #000000;\n}\n\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n.logout {\n\tmargin: 20px 0px 0px 10px;\n\tion-button {\n\t\tpadding: 10px 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t--background: white;\n\t\tcolor: #000000;\n\t\tfont-weight: 700;\n\t\tion-icon {\n\t\t\tzoom: 1;\n\t\t\tcolor: #000000;\n\t\t}\n\t}\n}\n\nion-row {\n\tmargin-top: 6px;\n}\n.header-wrap {\n\tmargin: 10px;\n}\n.lang-row {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tbackground: #80735d;\n\tpadding: 15px;\n\tion-icon {\n\t\tzoom: 1.3;\n\t}\n}\n.lang-section {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-button {\n\t\twidth: 48%;\n\t\t--border-color: white;\n\t\t--background: transparent;\n\t\t--border-color: white;\n\t\t--border-width: 2px;\n\t\t--border-style: solid;\n\t\tborder-radius: 10px;\n\t\t--border-radius: 10px;\n\t\toverflow: hidden;\n\t\tbackground: transparent;\n\t\tfont-weight: bold;\n\t}\n\tion-button {\n\t\t&.selected {\n\t\t\t--border-style: solid;\n\t\t\t--border-color: white;\n\t\t\t--border-width: 2px;\n\t\t\t--background: white;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n.icon-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-left: 10px;\n    ion-icon {\n\t\tmargin: 0px !important;\n\t\tpadding: 0px !important;\n\t\tzoom: 1.6;\n\t}\n}\n\n.lang-block {\n\tmargin-top: auto;\n}\n\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.link {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.top-corner {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0;\n\twidth: 17.3%;\n\taspect-ratio: 114 / 153;\n\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
